import { handleError } from "../common/ErrorUtil";

import { executeGraphqlLoop } from "./BaseApi";
import { listOfficeInfos } from "./graphql/queries";

/**
 * 拠点一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListOfficeInfos() {
  const params = {
    nextToken: null,
  };
  const key = "listOfficeInfos";
  const { data, error } = await executeGraphqlLoop(
    listOfficeInfos,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      officeInfos: data[key].items,
    };
  } else {
    response.data = {
      officeInfos: [],
    };
  }

  return response;
}

export default executeListOfficeInfos;
